import { Tabs } from 'antd';

import { useNavigate, useParams } from 'react-router-dom';
import { StickyContainer, Sticky } from 'react-sticky';
import useQuery from '../../../../util/useQuery';
import Tab5 from '../RopaDetail/Tab5';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import Tab3 from './Tab3';
import Tab4 from './Tab4';
import Tab6 from './Tab5';
import { ROUTER } from '../../../../constants/router';
import { useTranslation } from 'react-i18next';
import UserService from '../../../../services/UserService';
import { useEffect, useState } from 'react';
import { STATUS_ID as STATUS } from '../../STATUS_ID';

const { TabPane } = Tabs;

const renderTabBar = (props, DefaultTabBar) => (
    <Sticky bottomOffset={80}>
        {({ style }) => (
            <DefaultTabBar
                {...props}
                className="bg-white z-50"
                style={{ ...style }}
            />
        )}
    </Sticky>
);

export default function TabsDetail({
    detail,
    editMode,
    openTabDB,
    storageLocation,
    currentUser,
    detailInfo
}) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { activityId, menu, tab, dsrTaskId } = useParams();
    const params = useQuery();
    const currentPackage = UserService.currentPackage();
    const [isNoPermission, setIsNoPermission] = useState(false);

    const role = UserService.role().toLowerCase();
    const superAdmin = ['super admin'].includes(role);

    useEffect(() => {
        if (detailInfo?.statusId === STATUS.WAITING_FOR_REVIEW) {
            if (superAdmin) {
                setIsNoPermission(false);
            } else {
                if (detailInfo?.reviewer) {
                    if (currentUser !== detailInfo?.reviewer) {
                        setIsNoPermission(true);
                    } else {
                        setIsNoPermission(false);
                    }
                } else {
                    setIsNoPermission(false);
                }
            }
        } else {
            setIsNoPermission(false);
        }
    }, [detailInfo]);

    return (
        <div className="bg-white rounded-xl p-4 py-6 my-4 col-span-2">
            <StickyContainer>
                <Tabs
                    onChange={(key) => {
                        if (menu === 'ra') {
                            navigate(
                                `${ROUTER.RISK_MANAGEMENT.RA}/${menu}/${activityId}/view?tab=${key}`
                            );
                        } else if (menu === 'rr') {
                            navigate(
                                `${ROUTER.RISK_MANAGEMENT.RR}/${menu}/${activityId}/view?tab=${key}`
                            );
                        } else if (menu === 'ropa') {
                            navigate(
                                `${ROUTER.DS_360.MY_TASK}/${tab}/${dsrTaskId}/${menu}/${activityId}/view?tab=${key}`
                            );
                        } else {
                            navigate(
                                `${ROUTER.DS_INVENTORY.ROPA}/${activityId}/view?tab=${key}`
                            );
                        }
                    }}
                    activeKey={params.get('tab') || '1'}
                    renderTabBar={renderTabBar}
                >
                    <TabPane tab={t('RoPA.DataCollection')} key={1}>
                        <Tab1
                            collectData={detail?.collectData}
                            editMode={editMode}
                            isNoPermission={isNoPermission}
                            detailInfo={detailInfo}
                        />
                    </TabPane>
                    <TabPane tab={t('RoPA.TypeOfPersonalData')} key={2}>
                        <Tab2
                            categoryPersonalData={detail?.categoryPersonalData}
                            editMode={editMode}
                            isNoPermission={isNoPermission}
                            detailInfo={detailInfo}
                        />
                    </TabPane>
                    <TabPane tab={t('RoPA.Reference')} key={3}>
                        <Tab3
                            referenceDocuments={detail?.referenceDocuments}
                            editMode={editMode}
                            isNoPermission={isNoPermission}
                            detailInfo={detailInfo}
                        />
                    </TabPane>
                    <TabPane tab={t('RoPA.StorageAndDestruction')} key={4}>
                        <Tab4
                            collectDataDestruction={
                                detail?.collectDataDestruction
                            }
                            editMode={editMode}
                            storageLocation={storageLocation}
                            isNoPermission={isNoPermission}
                            detailInfo={detailInfo}
                        />
                    </TabPane>
                    {openTabDB && currentPackage === 4 && (
                        <TabPane tab={t('RoPA.Database')} key={5}>
                            <Tab6 isNoPermission={isNoPermission} detailInfo={detailInfo} />
                        </TabPane>
                    )}
                    <TabPane tab={t('RoPA.DataController')} key={6}>
                        <Tab5 dcDpo={detail?.dcDpo} isNoPermission={isNoPermission} detailInfo={detailInfo} />
                    </TabPane>
                </Tabs>
            </StickyContainer>
        </div>
    );
}
